export const ACTION_STATUS = {
  todo: 'todo',
  inProgress: 'in-progress',
  done: 'done',
} as const
